module.exports = __webpack_public_path__ + "static/transfer_ownership2-5ae68558d8f74ed8bff89e0a94b1fdc9.png";